import React, { Fragment, useCallback, useContext, useEffect, useState } from 'react';
import moment from 'moment-timezone';

// import { Cron } from 'react-js-cron';

import { NavLink, Route, Switch, useHistory, useLocation, useParams } from "react-router-dom";
import { ActionButton, BaseButton, Breadcrumb, Button, DefaultButton, Dialog, DialogFooter, DialogType, Dropdown, IBreadcrumbItem, Icon, IconButton, IDropdownOption, PrimaryButton, SearchBox, Shimmer, TextField } from "office-ui-fabric-react";
import { getBoardMetrics, getBoardProfiles, WsScoreDashboard, WsServiceDashboard, WsTriage } from "./ScoreDashboard";



import { WsDecodeBoardInterface, WsDecodeData, WsDecodeSource, WsDecodeProfile, WsDecodeTable } from 'wsp-core/src/interfaces';



import { Loading } from "../../Shared";

import { apiGet, apiPost } from "../../../helpers-sales";



import { getProfileList } from "../../../decode-profiles";

import { WsDecodeAdminActions, WsDecodeAdminMetrics, WsDecodeMetricList } from "./DecodeMetrics";

import { WsDecodeDataSourceDialog } from "./DecodeDataSources";

import { WsDecodeContext } from "../DecodeContext";

import { DecodeTableReport } from "./DecodeTableReport";
import { DecodeDateRange } from "../../../decode-filters";



import 'antd/dist/antd.css';

import 'react-js-cron/dist/styles.css';

import './Page.scss';

import './DecodePage.scss';
import { WsAppContext } from "../../AppContext";
import { WsAiHubPage } from "../../AiHub/AiHubPage";
import { AvanadeAiAgent } from "../../AiAgent/AiAgent";



// const data: WsWheelItem[] = [
//   { name: 'Support',     value: 100 },
//   { name: 'Performance', value: 100 },
//   { name: 'Usage',       value: 100 },
//   { name: 'Sentiment',   value: 100 },
//   { name: 'Innovation',  value: 100 }
// ];



// const dataLevel2: WsWheelItem[][] = [

//   [
//     { name: 'First Contact\nResolution',             value: 100 },
//     { name: 'Mean Time\nTo Resolve',                 value: 100 },
//     { name: 'Proactive\nResolution (%)',             value: 100 },
//     { name: 'Service\nRequests\nAutomated (%)',      value: 100 },
//     { name: 'Ticket\nAvoidance',                     value: 100 }
//   ],

//   [
//     { name: 'Uptime',                                        value: 100 },
//     { name: 'Device\nStartup\nTime',                         value: 100 },
//     { name: 'Device\nExperience\nScore',                     value: 100 },
//     { name: 'Prod & Collab\nApplication\nExperience Score', value: 100}
//   ],

//   [
//     { name: 'Technology\nAdoption',                     value: 100 },
//     { name: 'Digital\nChannel\nAdoption',               value: 100 },
//     { name: 'Accessible\nFeature\nUsage',               value: 100 }
//   ],

//   [
//     { name: 'DWP Net\nPromoter Score',                                    value: 100 },
//     { name: 'Likes',                         value: 100 },
//     { name: 'Star Rating',                     value: 100 },
//     { name: 'Sentiment\nFeedback', value: 100},
//     { name: 'Engagement\nFeedback', value: 100 }
//   ],

//   [
//     { name: 'Quality\nIdeas\nGenerated',                                    value: 100 },
//     { name: 'Ideas\nExperimented\nPrototyped',                         value: 100 },
//     { name: 'GenAI & Automation\nStory Point\nVelocity',                     value: 100 },
//     { name: 'Value\nRealised (ROI)', value: 100}
//   ]

// ];




const isActive = (pathname: string, path: string, startsWith?: boolean) => {
  if (startsWith) {
    return pathname.toLowerCase().indexOf(path) === 0;
  } else {
    return pathname === path;
  }
};




const getParentList = (boardItem: WsDecodeBoardInterface, boardList: WsDecodeBoardInterface[], parentList: WsDecodeBoardInterface[]): WsDecodeBoardInterface[] => {

  let parentItem: WsDecodeBoardInterface | undefined = undefined;

  boardList.forEach((board) => {

    getBoardProfiles(board).forEach((profile) => {

      if (profile.boardId === boardItem.id) {
        parentItem = board;
      }
    });

    // boardList.find((item) => `${item.id}` === boardId);
  });


  
  if (parentItem) {

    // parentList.push(parentItem);

    // getParentList(parentItem, boardList, parentList);

    return [ ...getParentList(parentItem, boardList, parentList), parentItem, ...parentList ];


  } else {
    return parentList;
  }
};




export const WsBreadcrumb = (props: {
  boardList: WsDecodeBoardInterface[] | undefined
}) => {

  const history = useHistory();

  const params: { boardId?: string, metricId?: string } = useParams();



  let items: IBreadcrumbItem[] = [];




  if (params.boardId && props.boardList) {




    const boardItem = props.boardList.find((item) => `${item.id}` === params.boardId);

    if (boardItem && boardItem.id !== 1) {

      const parentList = getParentList(boardItem, props.boardList, []);

      console.log(parentList);

      parentList.forEach((item) => {

        items.push({
          text: item.name,
          key: `board-${item.id}`,
          onClick: () => {
            if (item.id === 1) {
              history.push(`/deliver/decode`);
            } else {
              history.push(`/deliver/decode/dashboard/${item.id}`);
            }
          }
        });
      });

      const metricItem = getBoardMetrics(boardItem).find((item) => `${item.id}`.toLowerCase() === `${params.metricId}`.toLowerCase());

      if (metricItem) {

        items.push({
          text: boardItem.name,
          key: `board-${boardItem.id}`,
          onClick: () => {
            history.push(`/deliver/decode/dashboard/${boardItem.id}`);
          }
        });

        items.push({
          text: metricItem.name,
          key: `metric-${metricItem.id}`
        });

      } else {

        items.push({
          text: boardItem.name,
          key: `board-${boardItem.id}`
        });
      }
    }



    



    // const boardItem = props.boardList?.find((item) => `${item.id}` === params.boardId);

    // if (boardItem && boardItem.id !== 1 && params.metricId) {

    //   const metricItem = getBoardMetrics(boardItem).find((item) => `${item.id}`.toLowerCase() === `${params.metricId}`.toLowerCase());

    //   items = [

    //     { text: 'Dashboard', key: 'd1', onClick: () => {
    //         history.push(`/deliver/decode`);
    //       }
    //     },

    //     { text: boardItem.name, key: 'd2', onClick: () => {
    //         history.push(`/deliver/decode/dashboard/${boardItem.id}`);
    //       }
    //     },

    //     { text: metricItem ? metricItem.name : 'Metric', key: 'm1' }
    //   ]; 

    // } else {

    //   items = [

    //     { text: 'Dashboard', key: 'd1', onClick: () => {
    //         history.push(`/deliver/decode`);
    //       }
    //     },

    //     { text: boardItem ? boardItem.name : 'Board', key: 'd2' }
    //   ];
    // }

  } else {

    items = [
      { text: 'Dashboard',    key: 'm1' }
    ];
  }




  return (
    <Breadcrumb
      items={items}
      maxDisplayedItems={10}
      // ariaLabel="Breadcrumb with items rendered as links"
      overflowAriaLabel="More links"
    />
  )
};




const WsDecodeAdminProfiles = (props: {}) => {

  const [ profileList, setProfileList ] = useState<WsDecodeProfile[]>(getProfileList());

  return (
    <div className="ws-decode-admin-profiles">

      <br />

      <table className="table is-hoverable is-fullwidth">
        <thead>
          <tr>
            <th>Name</th>
            <th>Type</th>
            <th>Primary Identifier</th>
            <th>Identifier Value</th>
          </tr>
        </thead>
        <tbody>
          {
            profileList.map((profileItem, index) => {
              return (
                <tr key={`ws-decode-profile-item-${index}`}>
                  <td>{profileItem.name}</td>
                  <td>{profileItem.type}</td>
                  <td>{profileItem.primaryIdentifier}</td>
                  <td>{profileItem.identifierValue}</td>
                </tr>
              );
            })
          }
        </tbody>
      </table>
    </div>
  );
};






const startDate = moment().subtract(1, 'year').startOf('month');
const endDate = moment().subtract(1, 'month').endOf('month');






const WsDecodePage = (props: {}) => {

  const appContext = useContext(WsAppContext);

  // const [ tab, setTab ] = useState<string>('dashboard');

  // const navigate = useNavigate();

  const history = useHistory();

  const currentLocation = useLocation();



  const [ selectedDateRange, setSelectedDateRange ] = useState<DecodeDateRange>({ start: startDate.toDate(), end: endDate.toDate() });

  const [ selectedRegionalPartnershipId, setSelectedRegionalPartnershipId ] = useState<string>('');

  const [ selectedLocalAuthorityId, setSelectedLocalAuthorityId ] = useState<string>('');

  const [ selectedSchoolTypeId, setSelectedSchoolTypeId ] = useState<string>('');

  const [ selectedSchoolId, setSelectedSchoolId ] = useState<string>('');



  const [ newDataSourceDialog, setNewDataSourceDialog ] = useState<string>('');

  const [value, setValue] = useState('30 5 * * 1,6');



  const [ boardList, setBoardList ] = useState<WsDecodeBoardInterface[] | undefined>(undefined);

  const loadBoards = useCallback(async () => {

    const result = await apiGet(`/decode/boards`);

    if (result && Array.isArray(result.decodeBoardList)) {
      const resultData = result.decodeBoardList as WsDecodeBoardInterface[];
      // console.log(resultData);
      setBoardList(resultData);
    }

  }, []);

  useEffect(() => {
    loadBoards();
  }, []);



  const deploymentInProgress = true;



  return (
    <div className="ws-deliver-page ws-deliver-decode-page">

      <WsDecodeContext.Provider
        value={{

          selectedDateRange, setSelectedDateRange,


          selectedRegionalPartnershipId, setSelectedRegionalPartnershipId,

          selectedSchoolTypeId, setSelectedSchoolTypeId,

          selectedSchoolId, setSelectedSchoolId,

          selectedLocalAuthorityId, setSelectedLocalAuthorityId,

        }}
      >

        {/* tabs */}

        <div className="ws-deliver-page-header">

          <div className="tabs is-medium is-boxed">
            <ul>
              {
                appContext?.theme === 'nestle'
                ?
                <></>
                :
                <>
                  <li className="ws-deliver-decode-page-title">
                    <h1>
                      Decode
                    </h1>
                  </li>
                </>
              }

              {/* <NavLink activeClassName="is-active" to="/deliver/decode"           isActive={() => isActive(currentLocation.pathname, '/deliver/decode', false)}>Dashboard</NavLink>
              <NavLink activeClassName="is-active" to="/deliver/decode/insights"        isActive={() => isActive(currentLocation.pathname, '/deliver/decode', true)}>Insights</NavLink>
              <NavLink activeClassName="is-active" to="/deliver/decode/value-tracker" isActive={() => isActive(currentLocation.pathname, '/deliver/decode', true)}>Value Tracker</NavLink>
              <NavLink activeClassName="is-active" to="/deliver/decode/service"       isActive={() => isActive(currentLocation.pathname, '/deliver/decode', true)}>Service</NavLink>
              <NavLink activeClassName="is-active" to="/deliver/decode/admin"         isActive={() => isActive(currentLocation.pathname, '/deliver/decode', true)}>Admin</NavLink> */}

              {/* <li className={ isActive(currentLocation.pathname, '/deliver/decode',               false) ? 'is-active' : '' }><a onClick={() => { history.push('/deliver/decode')               }}>360</a></li> */}



              <li className={(isActive(currentLocation.pathname, '/deliver/decode',                    false)
                           || isActive(currentLocation.pathname, '/deliver/decode/dashboard',          true)) ? 'is-active' : '' }><a onClick={() => { history.push('/deliver/decode')                  }}>Decode</a></li>



              {/* <li className={ isActive(currentLocation.pathname, '/deliver/decode/boards',         false) ? 'is-active' : '' }><a onClick={() => { history.push('/deliver/decode/boards')           }}>Boards</a></li> */}



              {
                [ 'hwb', 'nestle' ].includes(`${appContext?.theme}`)
                &&
                <li className={ isActive(currentLocation.pathname, '/deliver/decode/digital-maturity',   false) ? 'is-active' : '' }><a onClick={() => { history.push('/deliver/decode/digital-maturity') }}>Digital Maturity</a></li>
              }

              {
                [ 'nestle' ].includes(`${appContext?.theme}`)
                &&
                <>
                  <li className={ isActive(currentLocation.pathname, '/deliver/decode/use-cases', false) ? 'is-active' : '' }><a onClick={() => { history.push('/deliver/decode/use-cases') }}>Use Cases</a></li>
                  <li className={ isActive(currentLocation.pathname, '/deliver/decode/agent',     false) ? 'is-active' : '' }><a onClick={() => { history.push('/deliver/decode/agent')     }}>Agent</a></li>
                </>
              }



              <li className={ isActive(currentLocation.pathname, '/deliver/decode/insights',           false) ? 'is-active' : '' }><a onClick={() => { history.push('/deliver/decode/insights')         }}>Insights</a></li>

              <li className={ isActive(currentLocation.pathname, '/deliver/decode/admin',              true)  ? 'is-active' : '' }><a onClick={() => { history.push('/deliver/decode/admin')            }}>Admin (Decode)</a></li>



              {/* <li className={ isActive(currentLocation.pathname, '/deliver/decode/value-tracker', false) ? 'is-active' : '' }><a onClick={() => { history.push('/deliver/decode/value-tracker') }}>Value Tracker</a></li> */}

              {/* <li className={ isActive(currentLocation.pathname, '/deliver/decode/service',       false) ? 'is-active' : '' }><a onClick={() => { history.push('/deliver/decode/service')       }}>Service</a></li> */}
            </ul>
          </div>

        </div>



        {/* menu */}

        <Route path="/deliver/decode/admin">
          <div className="ws-deliver-page-menu">
            <a className={ isActive(currentLocation.pathname, '/deliver/decode/admin',              false) ? 'ws-deliver-page-menu-item is-active' : 'ws-deliver-page-menu-item' } onClick={() => { history.push('/deliver/decode/admin')              }}>Data Sources</a>
            <a className={ isActive(currentLocation.pathname, '/deliver/decode/admin/metrics',      false) ? 'ws-deliver-page-menu-item is-active' : 'ws-deliver-page-menu-item' } onClick={() => { history.push('/deliver/decode/admin/metrics')      }}>Metrics</a>
            <a className={ isActive(currentLocation.pathname, '/deliver/decode/admin/data-browser', false) ? 'ws-deliver-page-menu-item is-active' : 'ws-deliver-page-menu-item' } onClick={() => { history.push('/deliver/decode/admin/data-browser') }}>Data Browser</a>
            <a className={ isActive(currentLocation.pathname, '/deliver/decode/admin/profiles',     false) ? 'ws-deliver-page-menu-item is-active' : 'ws-deliver-page-menu-item' } onClick={() => { history.push('/deliver/decode/admin/profiles')     }}>Profiles</a>
            <a className={ isActive(currentLocation.pathname, '/deliver/decode/admin/actions',      false) ? 'ws-deliver-page-menu-item is-active' : 'ws-deliver-page-menu-item' } onClick={() => { history.push('/deliver/decode/admin/actions')      }}>Actions</a>
          </div>
        </Route>



        {/* page */}

        <Switch>



          <Route path="/deliver/decode/insights">
            <WsTriage />
          </Route>



          <Route path="/deliver/decode/value-tracker">
            <div>
              {/* <WsWheelRecharts
                data={data}
                dataLevel2={dataLevel2}
              /> */}
            </div>
          </Route>








          {/* admin - profiles */}

          <Route path="/deliver/decode/admin/profiles">
            <WsDecodeAdminProfiles />
          </Route>



          {/* admin - data browser */}

          <Route path="/deliver/decode/admin/data-browser">
            <>
              <WsDataBrowser />
            </>
          </Route>



          {/* admin - metrics */}

          <Route path="/deliver/decode/admin/metrics">
            <>
              <WsDecodeAdminMetrics />
            </>
          </Route>



          {/* admin - data sources */}
          <Route exact path="/deliver/decode/admin">

            {/* <Cron value={value} setValue={setValue} /> */}

            <div style={{
              textAlign: 'right'
            }}>
              <ActionButton
                className="ws-decode-admin-add-label"
                iconProps={{
                  iconName: 'CircleAddition'
                }}
                style={{
                  
                }}
                onClick={async () => {
                  setNewDataSourceDialog('NEW');
                }}
              >
                Add Data Source
              </ActionButton>
            </div>

            <br />
            <table className="table is-hoverable is-fullwidth">
              <thead>
                <tr>
                  <th>Entity</th>
                  <th>Source</th>
                  <th>Schedule</th>
                  <th>Last Sync</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>

                <tr>
                  <td>User</td>
                  <td>Microsoft Graph</td>
                  <td>Daily 06:00</td>
                  <td>Today 06:00</td>
                  <td>Success</td>
                </tr>
                <tr>
                  <td>User</td>
                  <td>Intune</td>
                  <td>Daily 06:30</td>
                  <td>Today 06:30</td>
                  <td>Success</td>
                </tr>

                <tr>
                  <td>User</td>
                  <td>Nexthink</td>
                  <td>Daily 07:00</td>
                  <td>Today 07:00</td>
                  <td>Success</td>
                </tr>

                <tr>
                  <td>User</td>
                  <td>ServiceNow</td>
                  <td>Weekly on Monday 12:00</td>
                  <td>Yesterday 12:00</td>
                  <td>Success</td>
                </tr>

                <tr>
                  <td>User</td>
                  <td>Workday</td>
                  <td>Weekly on Friday 22:00</td>
                  <td>4 days ago</td>
                  <td>Success</td>
                </tr>

                <tr>
                  <td>User</td>
                  <td>Happy Signals</td>
                  <td>Weekly on Thursday 22:00</td>
                  <td>5 days ago</td>
                  <td>Success</td>
                </tr>

                <tr>
                  <td>User</td>
                  <td>Surveil</td>
                  <td>Daily 06:00</td>
                  <td>Today 06:00</td>
                  <td>Success</td>
                </tr>

                {/* group */}

                <tr>
                  <td>Group</td>
                  <td>Microsoft Graph</td>
                  <td>Daily 08:00</td>
                  <td>Today 08:00</td>
                  <td>Success</td>
                </tr>

                {/* device */}

                <tr>
                  <td>Device</td>
                  <td>Intune</td>
                  <td>Daily 06:00</td>
                  <td>Today 06:00</td>
                  <td>Success</td>
                </tr>
                <tr>
                  <td>Device</td>
                  <td>Nexthink</td>
                  <td>Weekly on Monday 03:00</td>
                  <td>Yesterday 03:00</td>
                  <td>Success</td>
                </tr>
                <tr>
                  <td>Device</td>
                  <td>Log Analytics</td>
                  <td>Weekly on Monday 05:00</td>
                  <td>Yesterday 05:00</td>
                  <td>Success</td>
                </tr>

                {/* application */}

                <tr>
                  <td>Application</td>
                  <td>Microsoft Graph</td>                
                  <td>Weekly on Tuesday 06:00</td>
                  <td>Today 06:00</td>
                  <td>Success</td>
                </tr>
                <tr>
                  <td>Application</td>
                  <td>Intune</td>
                  <td>Weekly on Tuesday 06:00</td>
                  <td>Today 06:00</td>
                  <td>Success</td>
                </tr>
              </tbody>
            </table>
            {
              newDataSourceDialog
              &&
              <WsDecodeDataSourceDialog
                onCancel={() => {
                  setNewDataSourceDialog('');
                }}
                onSave={async () => {
                  setNewDataSourceDialog('');
                }}
              />
            }
          </Route>



          {/* admin - metrics */}

          <Route path="/deliver/decode/admin/actions">
            <>
              <WsDecodeAdminActions />
            </>
          </Route>



          {/* admin - page */}

          <Route path="/deliver/decode/admin/:page">
            <br />
            <Shimmer />
            <br />
            <Shimmer width="80%" />
            <br />
            <Shimmer width="60%" />
            <br />
            <Shimmer width="40%" />
            <br />
            <br />
            <br />
          </Route>



          <Route path="/deliver/decode/service" component={WsServiceDashboard} />



          {/* <Route path="/deliver/decode/(dashboard)?/:dashboardId?" component={WsScoreDashboard} /> */}
          {/* (page)?/:page? */}



          <Route path="/deliver/decode/digital-maturity">
            <DecodeTableReport />
          </Route>



          <Route path={`/deliver/decode/use-cases`} component={WsAiHubPage} />



          <Route path="/deliver/decode/agent">
            <div>
              <AvanadeAiAgent
                name="DEX Bot"
                url={ process.env.NODE_ENV === 'production' ? 'https://adp-demo-019cdd35-ai-api.azurewebsites.net/workflow' : 'http://localhost:5050/workflow' }
              />
            </div>
          </Route>



          <Route path="/deliver/decode/dashboard/:boardId/metrics/:metricId">
            <WsBreadcrumb boardList={boardList} />
            <WsDecodeMetricList boardList={boardList} />
          </Route>

          <Route path="/deliver/decode/dashboard/:boardId">
            <WsScoreDashboard boardList={boardList} setBoardList={setBoardList} loadBoards={loadBoards} />
          </Route>

          <Route path="/deliver/decode">
            <WsScoreDashboard boardList={boardList} setBoardList={setBoardList} loadBoards={loadBoards} />
          </Route>



          {/* <Route>
            <br />
            <Shimmer />
            <br />
            <Shimmer width="80%" />
            <br />
            <Shimmer width="60%" />
            <br />
            <Shimmer width="40%" />
            <br />
            <br />
            <br />
          </Route> */}

        </Switch>

      </WsDecodeContext.Provider>
    </div>
  );
};








const WsDataBrowser = (props: {}) => {

  const [ search, setSearch ] = useState<string>('');



  const [ modifiedAt, setModifiedAt ] = useState<Date | undefined>(undefined);

  const [ tableList, setTableList ] = useState<WsDecodeTable[] | undefined>(undefined);

  const loadTableList = useCallback(async () => {

    const result = await apiGet(`/decode/table-list`);

    if (result && Array.isArray(result.tableList)) {
      const resultData = result.tableList as WsDecodeTable[];
      // console.log(resultData);
      setTableList(resultData);
    }

    if (result.modifiedAt) {
      // setModifiedAt(new Date(result.modifiedAt));
      setModifiedAt(moment().subtract(30, 'days').toDate());
    } else {
      setModifiedAt(undefined);
    }

  }, []);



  const [ dataList, setDataList ] = useState<WsDecodeData[] | undefined>(undefined);

  const loadDataList = useCallback(async () => {

    const result = await apiGet(`/decode/data-list`);

    if (result && Array.isArray(result.dataList)) {
      const resultData = result.dataList as WsDecodeData[];
      // console.log(resultData);
      setDataList(resultData);
    }

  }, []);



  useEffect(() => {
    setTimeout(async () => {
      await loadDataList();
      await loadTableList();
    }, 100);
  }, []);



  if (tableList && modifiedAt && dataList) {

    console.log(`search : ${search}`);

    const dataListFiltered = dataList.filter((dataItem) => {

      if (search.length > 0) {

        if (`${dataItem.value}`.toLowerCase().indexOf(search.toLowerCase()) > -1) {
          return true;

        } else {
          return false;
        }

      } else {
        return false;
      }
    });

    return (
      <div className="ws-decode-data-browser">

        <div className="ws-statistic-timestamp">
          Updated: { moment(modifiedAt).fromNow() }
          <IconButton
            iconProps={{ iconName: 'Refresh' }}
            style={{ verticalAlign: 'middle', marginLeft: '5px', marginTop: '-2px' }}
            title="Refresh"
            ariaLabel="Refresh"
            onClick={async () => {

              setModifiedAt(undefined);

              const tableListRefresh = await apiPost(`/decode/table-list/refresh`, {});

              if (tableListRefresh && tableListRefresh.modifiedAt) {
                console.log(tableListRefresh);
              }

              const dataListRefresh = await apiPost(`/decode/data-list/refresh`, {});

              if (dataListRefresh && dataListRefresh.modifiedAt) {
                console.log(dataListRefresh);
              }

              await loadDataList();
              await loadTableList();
            }}
          />
        </div>

        <WsDecodeSearchBox
          setSearch={(searchValue: string) => {
            setSearch(searchValue);
          }}
        />

        {
          (
            dataListFiltered.length > 0
            &&
            dataListFiltered.length < 1000
          )
          ?
          <>
            <table className="table is-hoverable is-fullwidth">
              <thead>
                <tr>
                  <th>Data</th>
                  <th>Type</th>
                  <th>Source</th>
                  {/* <th>Field</th> */}
                  {/* <th>Source</th> */}
                </tr>
              </thead>
              <tbody>
                {
                  dataListFiltered.slice(0, 100).map((dataItem: WsDecodeData, index) => {
                    return (
                      <tr key={`ws-decode-data-item-${index}`}>
                        <td>{dataItem.value}</td>
                        <td>{dataItem.type}</td>
                        <td>
                          Table: {dataItem.table}<br />
                          Field: {dataItem.field}
                        </td>
                        {/* <td></td> */}
                        {/* <td>DECODE</td> */}
                      </tr>
                    );
                  })
                }
              </tbody>
            </table>
          </>
          :
          <>
            {
              dataListFiltered.length < 1
              ?
              <>No data match search criteria!</>
              :
              <>Too many data entries ({dataListFiltered.length}) match your search criteria, please narrow it down!</>
            }
          </>
        }
      </div>
    );

  } else {
    return (<Loading />);
  }
};









type WsSalesSearchBoxProps = {
  setSearch: (searchValue: string) => void;
};

const WsDecodeSearchBox = (props: WsSalesSearchBoxProps) => {

  // const [ focus, setFocus ] = useState<boolean>(false);

  const [ searchValue, setSearchValue ] = useState<string>('');

  return (
    <>
      <div className="ws-sales-solution-view-search">
        <SearchBox
          // styles={searchBoxStyles}
          placeholder="Search"
          // onEscape={(ev?: any) => {
          //   console.log('SearchBox : Custom onEscape Called');
          // }}
          // onClear={(ev?: any) => {
          //   console.log('SearchBox : Custom onClear Called');
          // }}
          onChange={(event?: React.ChangeEvent<HTMLInputElement> | undefined, newValue?: string | undefined) => {
            if (newValue || newValue === '') {
              setSearchValue(newValue);
              props.setSearch(newValue);
            }
          }}
          onSearch={(newValue: any) => {
            console.log('SearchBox : onSearch fired: ' + newValue);
          }}

          value={searchValue}
        />
      </div>
    </>
  );
};




































export {
  WsDecodePage,
  WsDecodeSearchBox
};
